import { render, staticRenderFns } from "./PassengerflowView.vue?vue&type=template&id=0b59c241&scoped=true"
import script from "./PassengerflowView.vue?vue&type=script&lang=js"
export * from "./PassengerflowView.vue?vue&type=script&lang=js"
import style0 from "./PassengerflowView.vue?vue&type=style&index=0&id=0b59c241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59c241",
  null
  
)

export default component.exports